const mode = {
    ALL: 0,
    REWARD: 1,
    TASK: 2,
    NFT: 3,
}

export { mode }